<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditContract"
        class="bg-black fixed h-screen bg-opacity-70 inset-0 z-50 w-full"
      >
        <form
          @submit.prevent="editContract"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full overflow-y-auto h-auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-50 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Edit Employee Contract</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="createContractError"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ createContractError }}
            </div>
          </transition>

          <!-- Contract Information -->
          <div class="p-2">
            <div
              class="grid grid-cols-1 sm:lg:grid-cols-2 lg:grid-cols-3 gap-5"
            >
              <div class="text-sm">
                <label class="block pb-1">Employment Type</label>
                <select
                  v-model="contractInfo.EmploymentType"
                  class="w-full border border-gray-300 rounded-md px-3 py-2"
                >
                  <option value="" disabled>Select Type</option>
                  <option
                    v-for="employmentType in employmentTypes"
                    :key="employmentType.Id"
                    :value="employmentType.Name"
                    :selected="
                      employmentType.Name === contractInfo.EmploymentType
                    "
                  >
                    {{ employmentType.Name }}
                  </option>
                </select>
              </div>

              <div class="text-sm">
                <label class="block pb-1">Job Title</label>
                <select
                  v-model="contractInfo.JobTitle"
                  class="w-full border border-gray-300 rounded-md px-3 py-2"
                >
                  <option value="" disabled>Select Job Title</option>
                  <option
                    v-for="jobTitle in jobTitles"
                    :key="jobTitle.Id"
                    :value="jobTitle.Name"
                    :selected="jobTitle.Name === contractInfo.JobTitle"
                  >
                    {{ jobTitle.Name }}
                  </option>
                </select>
              </div>

              <div class="text-sm">
                <label class="block pb-1">Start Date</label>
                <input
                  v-model="contractInfo.StartDate"
                  type="date"
                  placeholder="Select Start Date"
                  style="width: 100%"
                  class="border bg-gray-200 rounded-md px-3 py-2"
                />
              </div>

              <div class="text-sm">
                <label class="block pb-1">End Date</label>
                <input
                  v-model="contractInfo.EndDate"
                  type="date"
                  placeholder="Select End Date"
                  style="width: 100%"
                  class="border bg-gray-200 rounded-md px-3 py-2"
                />
              </div>

              <div class="text-sm">
                <label class="block pb-1">Status</label>
                <!-- {{ employmentStatus }} -->
                <select
                  v-model="contractInfo.EmploymentStatus"
                  class="w-full border border-gray-300 rounded-md px-3 py-2"
                >
                  <option value="" disabled>Select Status</option>
                  <option
                    v-for="status in employmentStatus"
                    :key="status.Id"
                    :value="status.Name"
                    :selected="status.Name === contractInfo.EmploymentStatus"
                  >
                    {{ status.Name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <!-- Action section -->
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
import { mapGetters } from "vuex";

export default {
  name: "EditEmployeeContract",
  props: ["showEditContract", "activeTab", "reload", "contractInfo"],
  components: { Loader },
  data() {
    return {
      loading: false,
      createContractError: null,

      employmentTypes: [],
      jobTitles: [],
      employmentStatus: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getCurrentEmployeeId"]),
  },
  created() {
    // Fetch employment types and job titles when the component is created
    this.fetchEmploymentTypes();
    this.fetchJobTitles();
    this.fetchEmploymentStatus();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    // /{organization}/employee/contract/v1/create
    editContract() {
      this.loading = true;
      this.contractInfo.EmployeeId = this.getCurrentEmployeeId;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      let data = {
        EmpContractId: this.contractInfo.Id,
        EmployementTypeId: this.employmentTypes.find(
          (type) =>
            type.Name.trim().toLowerCase() ===
            this.contractInfo.EmploymentType.trim().toLowerCase()
        )?.Id,
        JobTitleId: this.jobTitles.find(
          (title) =>
            title.Name.trim().toLowerCase() ===
            this.contractInfo.JobTitle.trim().toLowerCase()
        )?.Id,
        EmployementStatusId: this.employmentStatus.find(
          (status) =>
            status.Name.trim().toLowerCase() ===
            this.contractInfo.EmploymentStatus.trim().toLowerCase()
        )?.employmentStatusId,
        EmploymentStatus: this.contractInfo.EmploymentStatus,
        StartDate: this.contractInfo.StartDate,
        EndDate: this.contractInfo.EndDate,
      };

      axios
        .put(
          `${this.getOrganization}/employee/contract/${this.$ApiVersion}/edit`,
          JSON.stringify(data),
          options
        )
        .then(
          (response) => {
            this.loading = false;

            if (response.data.StatusCode == 200) {
              this.close();
              this.reload();
              (this.contractInfo = {
                EmployeeId: "",
                EmployementTypeId: "",
                JobTitleId: "",
                EmployementStatusId: "",
                StartDate: "",
                EndDate: "",
              }),
                this.$notify({
                  title: "Success",
                  message: response.data.StatusMessage,
                  type: "success",
                });
            } else {
              this.createContractError = response.data.StatusMessage;
              this.$notify.error({
                title: "Success",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.createContractError = error.message;
            this.$notify.error({ title: "Success", message: error.message });
          }
        );
    },
    fetchEmploymentTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/employementtype/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          if (response.data.StatusCode === 200) {
            this.employmentTypes = response.data.Data;
          } else {
            this.$notify.error({
              title: "Error",
              message: "Error fetching employment types",
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching employment types:", error);
          this.$notify.error({
            title: "Error",
            message: "Error fetching employment types",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchJobTitles() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/jobtitle/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          if (response.data.StatusCode === 200) {
            this.jobTitles = response.data.Data;
          } else {
            this.$notify.error({
              title: "Error",
              message: "Error fetching job titles",
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching job titles:", error);
          this.$notify.error({
            title: "Error",
            message: "Error fetching job titles",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchEmploymentStatus() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/employment/status/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          if (response.data.StatusCode === 200) {
            this.employmentStatus = response.data.Data;
          } else {
            this.$notify.error({
              title: "Error",
              message: "Error fetching employment status",
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching employment status:", error);
          this.$notify.error({
            title: "Error",
            message: "Error fetching employment status",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
